// We don't know the category, so look through them all
// and look for the slug
import { getEndPoint } from './getEndPoint'
export const getOrphanPage = slug =>
  import(/* webpackChunkName: "[request]" */ `wp-data/${slug}.json`)
    .catch(() => {
      const typesQueryString = [
        'fitness',
        'food',
        'health_education',
        'features',
        'marketing',
      ]
        .map(type => `type[]=${type}`)
        .join('&')

      return getEndPoint(`wp/v2/pages?${typesQueryString}&slug=${slug}&_embed`)
    })
    .then(pages => {
      if (pages.length === 0) {
        return Promise.reject('Page not found')
      }
      if (pages.length > 1) {
        pages = pages.sort((a, b) => b.acf.landing_page - a.acf.landing_page)
      }

      return Promise.resolve(pages[0])
    })
    .catch(error => Promise.reject(error))
